// src/api/userreport.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

export const exportUsersCustomized = async ({
  fields,
  file_type,
  year,
  month,
  user_ids,
}: {
  fields: string;
  file_type: "excel" | "pdf";
  year: number;
  month?: number;
  user_ids: string;
}) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/export/export/users/${file_type}/customized`,
      {
        headers: getAuthHeaders(),
        params: {
          fields,
          year,
          month,
          user_ids,
        },
        responseType: "blob",
      }
    );
    const blob = new Blob([res.data], { type: res.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `user_report.${file_type === "excel" ? "xlsx" : "pdf"}`;
    a.click();
    window.URL.revokeObjectURL(url);
    toast.success("User customized report downloaded successfully");
  } catch (error) {
    showAxiosError(error, "Failed to export user report");
    throw error;
  }
};
